import { render, staticRenderFns } from "./ProductFilters.vue?vue&type=template&id=d2152c82&scoped=true&"
import script from "./ProductFilters.vue?vue&type=script&lang=js&"
export * from "./ProductFilters.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilters.vue?vue&type=style&index=0&id=d2152c82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2152c82",
  null
  
)

export default component.exports